module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABHNCSVQICAgIfAhkiAAAAU1JREFUSInlVkuygyAQ7LHegchnL55MPVnIPkZO5LwFRgWGiPoqlarXK+2BaWF+At8Kpa56jy1EkS1GfJMcK3WuUzYJJDrHUPqrSAPQYG5iD29sAKx9tklB97UkbtwN5mYp+pNaBBT3mRhKEDUxD4C4xnRCYU8AWRDF3dqHeb0pdQXAET/ZiHV6T5agj9FRFO81mwRZkLhWp0ud60RGfLq0IKCPiaWRSBqqwlhtxat2Qz6r8P8SHxd8m6XqdJkjP15z0ByM7bsqbBi275JZu+GEY7tzrWw31urQRAyzAdH8DMB1GI7XbhW0fVdFnOuLrc89jPhxAr4uaeY6YmoXSaMdx8baZytxuwThdZzBADDT/AMwxrL11jp7UvDYlXpJk4e1pInqSU6k/Inxb1vbULqJfQRDKd1yYgBTkxqg+ZBDKvwmng9O+iXif6CP4xeIFp1Yn0qhjQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/SsendRicheng.png
// module id = GI9r
// module chunks = 1